import { render } from "./ChatInputMentionUserSuggestionList.vue?vue&type=template&id=59c78422&scoped=true&ts=true"
import script from "./ChatInputMentionUserSuggestionList.vue?vue&type=script&lang=ts"
export * from "./ChatInputMentionUserSuggestionList.vue?vue&type=script&lang=ts"

import "./ChatInputMentionUserSuggestionList.vue?vue&type=style&index=0&id=59c78422&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c78422"]])

export default __exports__